import { Dispatch, useCallback, useMemo } from "react";
import { useReleaseHeldEmailAction } from "../../../hooks/admin/useHeldEmailBulkAction";
import {
  HeldEmailQueueAction,
  HeldEmailQueueState,
} from "../../../hooks/admin/useHeldEmailQueueState";
import { HeldEmailListItem } from "../../../services/admin/systemEmails.service";
import { ConfirmReleaseHeldEmailsModal } from "./ConfirmReleaseHeldEmailsModal";

interface Props {
  state: HeldEmailQueueState;
  emails: HeldEmailListItem[];
  dispatch: Dispatch<HeldEmailQueueAction>;
}

export function HeldEmailReleaseDialog({ state, emails, dispatch }: Props) {
  const action = useReleaseHeldEmailAction(state, dispatch);
  const selected = useMemo(() => {
    const ids = new Set(state.pendingAction?.ids ?? []);
    return emails.filter((email) => ids.has(email.id));
  }, [emails, state.pendingAction]);
  const close = useCallback(
    () => dispatch({ type: "action", value: null }),
    [dispatch]
  );
  return (
    <ConfirmReleaseHeldEmailsModal
      emails={selected}
      loading={action.mutation.isPending}
      onClose={close}
      onConfirm={action.confirm}
      opened={state.pendingAction?.type === "release"}
    />
  );
}
